/**
 * Single source of truth for document authorship credits.
 *
 * The same JSON drives the UI, the whitepaper route, the PDF generator
 * (`scripts/generate-whitepaper-pdf.py`) and the pre-publish verifier
 * (`scripts/verify-whitepaper-pdf.py`), so text and PDF metadata can never
 * drift apart.
 */
import credits from "@/config/document-credits.json";

export const DOCUMENT_CREDITS = credits;

export const CREATOR_ALIAS = credits.creatorAlias;
export const ORIGINAL_CREATION_DATE = credits.originalCreationDate.display;
export const ORIGINAL_CREATION_DATE_NUMERIC = credits.originalCreationDate.numeric;
export const ORIGINAL_CREATION_DATE_ISO = credits.originalCreationDate.iso;
export const DOCUMENT_VERSION = credits.version;
export const DOCUMENT_TITLE = `${credits.documentTitle} ${credits.version}`;

/** "Concept & Framework created by X — Initial Release: <date>" */
export const CREDIT_LINE = `Concept & Framework created by ${CREATOR_ALIAS} — Initial Release: ${ORIGINAL_CREATION_DATE}`;

/** "Whitepaper v1.0 — Original Release: July 04, 2021" */
export const VERSION_BADGE = `Whitepaper ${DOCUMENT_VERSION} — Original Release: ${ORIGINAL_CREATION_DATE}`;

/** "Author & Creator: X" */
export const AUTHOR_LINE = `Author & Creator: ${CREATOR_ALIAS}`;

/** "Original Creation Date: July 04, 2021 (04.07.2021)" */
export const CREATION_DATE_LINE = `Original Creation Date: ${ORIGINAL_CREATION_DATE} (${ORIGINAL_CREATION_DATE_NUMERIC})`;
